document.addEventListener('DOMContentLoaded', () => {
    const appBox = document.querySelector('.app');
    if(appBox){
        let downloadButtons;
        let userAgent;
        let downloadLink = '';
        const qrcodesApp = document.querySelector('.qrcode_app');

        if (appBox) {
            // Get the reference to the <button> tag
            downloadButtons = document.querySelectorAll('.download_app');
            // Detect user agent to determine the device type
            userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (userAgent.includes('Android')) {
                // Android device
                downloadLink = 'https://play.google.com/store/apps/details?id=de.ewe.go.app';
            } else if (userAgent.includes('iPhone') || userAgent.includes('iPad') || userAgent.includes('iPod')) {
                // iOS device
                downloadLink = 'https://apps.apple.com/de/app/ewe-go/id1632031984';
            }
            downloadButtons.forEach((downloadButton) => {
                if (downloadLink !== '') {
                    // Attach click event listener
                    downloadButton.addEventListener('click', (event) => {
                        // Prevent the default action of the link/button (to prevent the page from refreshing in this case)
                        event.preventDefault();

                        // Navigate to the link
                        window.location.href = downloadLink;
                    });
                } else {
                    // hide download buttons
                    downloadButton.style.display = 'none';

                    // show QR Codes for the appstores
                    qrcodesApp.style.display = 'block';
                }
            });
        }
    }
});
